import { render } from "./PurchaseTableAnalyst.vue?vue&type=template&id=73c18274"
import script from "./PurchaseTableAnalyst.vue?vue&type=script&lang=js"
export * from "./PurchaseTableAnalyst.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__